import { InteractiveMapLocationSchema } from "@redotech/redo-model/draft-return/draft-return";
import * as z from "zod";

export const getCarrierLocations = {
  name: "getCarrierLocations" as const,
  input: z.object({
    carrier: z.string(),
    zip: z.string().optional(),
    country: z.string().optional(),
  }),
  output: z.object({ locations: z.array(InteractiveMapLocationSchema) }),
};
